/**
 * use-tanks — active tanks for a site (Wave 2 / #3).
 *
 * GET /v1/sites/:siteId/tanks (CREATE_JOB-gated). Enabled only when a site is
 * selected, so the third chained step (Operator → Site → Tank) in the New Job
 * modal fetches tanks only after a site is chosen.
 */

import { useApiQuery, useApiOpts } from '@lodex-pro/web-shared';

/** A single tank row from GET /v1/sites/:siteId/tanks. */
export interface Tank {
  readonly id: string;
  readonly name: string;
}

interface TanksResponse {
  readonly tanks: readonly Tank[];
}

/** Query key for a site's tanks. */
export const TANKS_QUERY_KEY = (siteId: string): readonly [string, string, string] =>
  ['sites', siteId, 'tanks'] as const;

/** Fetch active tanks for a site. Pass `''`/null to disable (no site selected). */
export function useTanks(
  apiOpts: ReturnType<typeof useApiOpts>,
  siteId: string,
): ReturnType<typeof useApiQuery<TanksResponse>> {
  return useApiQuery<TanksResponse>(apiOpts, `/v1/sites/${siteId}/tanks`, {
    queryKey: TANKS_QUERY_KEY(siteId || '__none__'),
    enabled: siteId.length > 0,
    staleTime: 60_000,
  });
}
